module.exports = __webpack_public_path__ + "img/hourglass-red.e260fa47.svg";